module.exports = __webpack_public_path__ + "img/banner04.c1dfacce.jpg";